import React, { useContext, useState, useEffect } from "react";
import {
  Card,
  Spinner,
  Table,
  Button,
  Modal,
  ToggleSwitch,
} from "flowbite-react";
import { Store } from "../context/store";
import { useNavigate } from "react-router-dom";
import { IoMdAddCircleOutline } from "react-icons/io";
import apiRequest from "../utils/apiRequest";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import DashboardLayout from "../components/layout/DashboardLayout";

function Role() {
  let store = useContext(Store);
  let [baseUrl] = store.url;
  let [roles, setRoles] = useState([]);
  let [msg] = useState("");
  let [singleStaff, setSingleStaff] = useState({});
  let [loading1, setLoading1] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [, setOpenModalAddStaff] = useState(false);
  const [openModalOut] = useState(false);
  const navigate = useNavigate();

  function onCloseModal() {
    setOpenModal(false);
  }

  const loadRoles = React.useCallback(async () => {
    try {
      let token = localStorage.getItem("royal-token");
      const url = `${baseUrl}/roles`;
      const { data } = await apiRequest(url, "GET", null, token);
      setRoles(data);
    } catch (error) {
      console.log(error);
    }
  }, [baseUrl]);

  useEffect(() => {
    Promise.all([loadRoles()])
      .then(() => setLoading1(false))
      .catch(() => setLoading1(false));
  }, [loadRoles]);

  let displayOnModal = (e) => {
    setSingleStaff(e);
    setOpenModal(true);
  };

  let logOut = () => {
    navigate("/");
  };
  console.log(singleStaff);
  // console.log(roles[0]?.permissions.roles);
  return (
    <>
      <title>Roles</title>
      <meta
        name="description"
        content="Roles Page to the Royalmines Property Office"
      />
      <DashboardLayout active="roles" animation="flip-up">
        <div className="mt-5">
            <div>
              <div className="mb-4">
                <h5 className="text-xl font-bold leading-none text-gray-900 dark:text-white">
                  Roles
                </h5>
                <div className="flex flex-wrap gap-2 mt-5 justify-end">
                  <Button
                    color="success"
                    onClick={() => setOpenModalAddStaff(true)}
                  >
                    <IoMdAddCircleOutline className="me-2" />
                    Add Role
                  </Button>
                </div>
              </div>
              {!loading1 ? (
                <>
                  <Card className="rounded-xl my-4">
                    <div className="overflow-x-auto overflow-y-scroll h-[45vh] scrollbar-always-visible">
                      <Table hoverable>
                        <Table.Head>
                          <Table.HeadCell>Title</Table.HeadCell>
                          <Table.HeadCell>Email</Table.HeadCell>
                          <Table.HeadCell>
                            <span className="sr-only">Edit</span>
                          </Table.HeadCell>
                        </Table.Head>

                        <Table.Body className="divide-y">
                          {roles.length === 0 ? (
                            <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                              <Table.Cell
                                colSpan={3}
                                className="text-center py-4"
                              >
                                No roles added yet.
                              </Table.Cell>
                            </Table.Row>
                          ) : (
                            roles.map((e, i) => (
                              <Table.Row key={i}>
                                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white capitalize">
                                  {e.title}
                                </Table.Cell>
                                <Table.Cell>
                                  <p
                                    className="font-medium text-cyan-600 hover:underline dark:text-cyan-500"
                                    onClick={() => displayOnModal(e)}
                                    style={{
                                      textDecoration: "none",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Viewsss
                                  </p>
                                </Table.Cell>
                              </Table.Row>
                            ))
                          )}
                        </Table.Body>
                      </Table>
                    </div>
                  </Card>
                </>
              ) : (
                <div className="flex justify-center items-center h-[100%]">
                  <Spinner
                    style={{ color: "#0078e7" }}
                    aria-label="info spinner example"
                    size="xl"
                  />
                </div>
              )}
            </div>
        </div>
      </DashboardLayout>

      {/* modal for singleRole */}
      <Modal
        dismissible
        show={openModal}
        size="xl"
        onClose={onCloseModal}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <div className="space-y-6">
            <h3 className="text-xl font-medium text-gray-900 dark:text-white capitalize">
              <strong>Title: </strong>
              {singleStaff?.title}
            </h3>
            <div className="flex justify-between align-middle items-center">
              <strong>Role: </strong>
              <br />
              <div>
                Read:{" "}
                <ToggleSwitch checked={singleStaff?.permissions?.roles?.read} />
              </div>
              <div>
                Write:{" "}
                <ToggleSwitch
                  checked={singleStaff?.permissions?.roles?.write}
                />
              </div>
              <div>
                Delete:{" "}
                <ToggleSwitch
                  checked={singleStaff?.permissions?.roles?.delete}
                />
              </div>
            </div>

            <div className="flex justify-between align-middle items-center">
              <strong>Staff: </strong>
              <br />
              <div>
                Read:{" "}
                <ToggleSwitch checked={singleStaff?.permissions?.staff?.read} />
              </div>
              <div>
                Write:{" "}
                <ToggleSwitch
                  checked={singleStaff?.permissions?.staff?.write}
                />
              </div>
              <div>
                Delete:{" "}
                <ToggleSwitch
                  checked={singleStaff?.permissions?.staff?.delete}
                />
              </div>
            </div>

            <div className="flex justify-between align-middle items-center">
              <strong>Property: </strong>
              <br />
              <div>
                Read:{" "}
                <ToggleSwitch
                  checked={!singleStaff?.permissions?.property?.read}
                />
              </div>
              <div>
                Write:{" "}
                <ToggleSwitch
                  checked={singleStaff?.permissions?.property?.write}
                />
              </div>
              <div>
                Delete:{" "}
                <ToggleSwitch
                  checked={singleStaff?.permissions?.property?.delete}
                />
              </div>
            </div>

            {/* <div className="w-full flex justify-center gap-3">
              <Dropdown label="Change Role" dismissOnClick={true}>
                {roles?.map((role) => {
                  return (
                    <Dropdown.Item
                      className="capitalize"
                      onClick={() => changeStaffRole(singleStaff.id, role.id)}
                    >
                      {role.title}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown>
              {singleStaff?.status === "active" && (
                <Button
                  color="failure"
                  onClick={() => changeStaffStatus(singleStaff.id, "inactive")}
                  disabled={loading2}
                >
                  Deactivate
                </Button>
              )}
              {singleStaff?.status === "inactive" && (
                <Button
                  color="success"
                  onClick={() => changeStaffStatus(singleStaff.id, "active")}
                  disabled={loading2}
                >
                  Activate
                </Button>
              )}
            </div> */}
          </div>
        </Modal.Body>
      </Modal>

      {/* modal for logout */}
      <Modal show={openModalOut} size="md" popup>
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              {msg}
            </h3>
            <div className="flex justify-center gap-4">
              <Button color="failure" onClick={() => logOut()}>
                {"OK"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* modal for add staff */}
      {/* <Modal
        show={openModalAddStaff}
        size="md"
        onClose={onCloseModalStaff}
        popup
      >
        <Modal.Header />
        <Modal.Body>
          <div className="space-y-6">
            <h3 className="text-xl font-medium text-gray-900 dark:text-white text-center">
              Register Staff
            </h3>
            <div className="flex justify-center">
              <small
                style={{
                  color: errorColor,
                  textAlign: "center",
                }}
              >
                {error}
              </small>
            </div>
            <div>
              <TextInput
                id="firstName"
                placeholder="First Name"
                value={staffDetails.firstName}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    firstName: event.target.value,
                  })
                }
                required
              />
            </div>
            <div>
              <TextInput
                id="lastName"
                placeholder="Last Name"
                value={staffDetails.lastName}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    lastName: event.target.value,
                  })
                }
                required
              />
            </div>
            <div>
              <TextInput
                id="email"
                placeholder="Email Address"
                value={staffDetails.email}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    email: event.target.value,
                  })
                }
                required
              />
            </div>
            <div>
              <Select
                id="Role"
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    role: event.target.value,
                  })
                }
                required
                style={{ textTransform: "capitalize" }}
              >
                <option value="">Select a Role</option>;
                {roles.map((role) => {
                  return <option value={role.id}>{role.title}</option>;
                })}
              </Select>
            </div>
            <div>
              <TextInput
                id="password"
                type="password"
                placeholder="Password"
                value={staffDetails.password}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    password: event.target.value,
                  })
                }
                required
              />
            </div>
            <div>
              <TextInput
                id="password1"
                type="password"
                placeholder="Confirm Password"
                value={staffDetails.confirmPassword}
                onChange={(event) =>
                  setStaffDetails({
                    ...staffDetails,
                    confirmPassword: event.target.value,
                  })
                }
                required
              />
            </div>
            <div className="w-full flex justify-center">
              <Button disabled={loading3} onClick={() => register()}>
                {loading3 ? "Loading..." : "Register"}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
}

export default Role;
